import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';

import { AppText } from '../AppText';
import styles from './searchEmptyStateStyles';

/**
 * SearchEmptyState - Displays when search returns no results
 */
function SearchEmptyState({ query = '', translation = {} }) {
  const accessibilityMessage = query
    ? (
        translation.search_accessibility_no_results ||
        'No results found for {query}. Try searching by city name, zip code, pantry name, or street address.'
      ).replace('{query}', query)
    : translation.search_accessibility_no_results_generic ||
      'No results found. Try searching by city name, zip code, pantry name, or street address.';

  const noPantriesMatch = (translation.search_no_pantries_match || 'No pantries match "{query}"').replace(
    '{query}',
    query
  );

  return (
    <View style={styles.container} accessibilityLabel={accessibilityMessage} accessibilityRole="text">
      <AppText style={styles.title} accessibilityRole="header">
        {translation.search_no_results_found || 'No results found'}
      </AppText>
      {query && (
        <AppText style={styles.subtitle} accessibilityLabel={noPantriesMatch}>
          {noPantriesMatch}
        </AppText>
      )}
      <AppText style={styles.suggestion} accessibilityRole="header">
        {translation.search_try_searching_by || 'Try searching by:'}
      </AppText>
      <AppText
        style={styles.suggestionItem}
        accessibilityLabel={
          translation.search_suggestion_city_accessibility || 'City name, for example, Brooklyn'
        }
      >
        • {translation.search_suggestion_city || 'City name (e.g., "Brooklyn")'}
      </AppText>
      <AppText
        style={styles.suggestionItem}
        accessibilityLabel={
          translation.search_suggestion_zipcode_accessibility || 'Zip code, for example, 10001'
        }
      >
        • {translation.search_suggestion_zipcode || 'Zip code (e.g., "10001")'}
      </AppText>
      <AppText
        style={styles.suggestionItem}
        accessibilityLabel={translation.search_suggestion_pantry_name || 'Pantry name'}
      >
        • {translation.search_suggestion_pantry_name || 'Pantry name'}
      </AppText>
      <AppText
        style={styles.suggestionItem}
        accessibilityLabel={translation.search_suggestion_street_address || 'Street address'}
      >
        • {translation.search_suggestion_street_address || 'Street address'}
      </AppText>
    </View>
  );
}

SearchEmptyState.propTypes = {
  query: PropTypes.string,
  translation: PropTypes.object,
};

export default SearchEmptyState;
